import PropTypes from 'prop-types';
import { Box, List, Typography } from '@mui/material';
import NavItem from './NavItem';
import { useEffect } from 'react';

const NavGroup = ({ item, moduleAccess }) => {

// rs sidebar
  const menu = true;
  const drawerOpen  = true;

  useEffect(() => {
    // console.log("iiiheymoduleAccess", moduleAccess);
  },[moduleAccess]);

  const navCollapse = item.children?.map((menuItem) => {

    // console.log("iiihey", menuItem);
    if(!moduleAccess.includes(menuItem.title))
    {
      return
    }
    

    switch (menuItem.type) {
      case 'collapse':
        return (
          <Typography key={menuItem.id} variant="caption" color="error" sx={{ p: 2.5 }}>
            collapse - only available in paid version
          </Typography>
        );
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  // console.log("navc", navCollapse);

  return (
 <List>
  <Box>
    {item.children?.map((menuItem, idx) => {
      if (!moduleAccess.includes(menuItem.title)) return null;
      switch (menuItem.type) {
        case 'collapse':
          return (
            <Typography key={menuItem.id} variant="caption" color="error" sx={{ p: 1 }}>
              collapse - only available in paid version
            </Typography>
          );
        case 'item':
          return (
            <Box
              key={menuItem.id}
              sx={{
                mb: 0.7,
                // px: 1,
                borderRadius: 4,
                background: "#fff",
                boxShadow: "0px 2px 1px 3px rgba(66, 61, 61, 0.11)",
                // transition: 'box-shadow 0.1s, background 0.1s',
              '&:hover': {
                  background: '#87CEEB',
                  boxShadow: "0 8px 24px 0 rgba(60,60,60,0.18)"
                }
              }}
            >
              <NavItem item={menuItem} level={1} />
            </Box>
          );
        default:
          return (
            <Typography key={menuItem.id} variant="h6" color="error" align="center">
              Fix - Group Collapse or Items
            </Typography>
          );
      }
    })}
  </Box>
</List>
  );
};

NavGroup.propTypes = {
  item: PropTypes.object,
};

export default NavGroup;
